import React, { Component, useState } from "react";
import db from "../../pages";
import { FaAngleDown, FaAngleRight } from "react-icons/fa"
import { fetchData } from "../common/networkRequests";
import { RelevantIcon, unsetAllPopovers, handleFilter, toggleFullReport, closeSidebar } from "../oro-module/commonFunctions";
import { handlePageChange } from "../oro-module/ajaxdata";

// import "../../styles/sidebar.css"
import "./styles.css";
import { Alert, UncontrolledTooltip } from "reactstrap";


const DashboardList = ({ current }) => {
  const { currentPage } = current.props.parentState;

  let dash = [1, 2, 3, 4, 5];

  return (
    <div className="dashboard_selector_container">
      {dash.map((d, idx) => <div onClick={() => handlePageChange({ item: { fastpath: 'dashboard' + d, label: "x" }, current })} className={`hand dashboard_selector_btn ${currentPage == 'dashboard' + d ? "active" : ""}`} key={idx}>{d}</div>)}
    </div>
  )
}


const RightSidebarIcons = ({ current, form, readOnly }) => {
  const sidebarItems = [
    // { id: "history", label: "History", icon: "history", style: { color: !readOnly ? "#3282b8" : "gray" }, tip: "History" },

    // {id:"export", label: "Export", icon: "export", style: { color: "#3282b8" }, tip: "Export" },
    { id: "print", label: "Print", icon: !readOnly ? "printer-color" : "printer-color-disabled", tip: "Create As" },
    // { id: "share", label: "Share", icon: "share", style: { color: !readOnly ? "#3282b8" : "gray" }, tip: "Share" },
    // { id: "table", label: "Columns", icon: "present-slide", style: { color: !readOnly ? "#3282b8" : "gray" }, tip: "Present" },
    // { id: "charting", label: "Charting", icon: !readOnly ? "surface-chart-color" : "surface-chart", tip: "Chart" },
  ]

  let { rightSidebarOpen } = current.props.parentState;

  const handleRightSidebarControl = (id) => {
    if (!readOnly) {
      // check if 
      let { OriginalData } = current.props.parentState;
      unsetAllPopovers();

      if (!OriginalData || OriginalData.length == 0) {
        let searchbtn = document.getElementById('action-button-search');
        if (searchbtn) {
          searchbtn.click();
        }
      }


      current.props.liftGlobalState({ name: 'showGeneralControl' }, true);

      if (rightSidebarOpen == id) {
        current.props.liftGlobalState({ name: "rightSidebarOpen" }, false);
        current.props.liftGlobalState({ name: 'chartBoxOpen' }, false);
        current.props.liftGlobalState({ name: 'showGeneralControl' }, false);


        // document.getElementById("general-controls").style.visibility = "hidden";
        // document.getElementById("general-controls").style.width = "0px";
      } else {
        current.props.liftGlobalState({ name: "rightSidebarOpen" }, id);
        current.props.liftGlobalState({ name: 'showGeneralControl' }, true);

        // document.getElementById("general-controls").style.visibility = "visible";
        // document.getElementById("general-controls").style.width = "20%";
      }
    }
  }


  return (
    <div
      id="sidebar"
      className="col-sm-12"
      style={{ height: "100%", overflow: "auto", padding: 5, paddingTop: (!form || form.length == 0) ? 5 : 25 }}
    >
      {sidebarItems.map(({ id, icon, style = {}, tip }, idx) =>
        <span onClick={() => handleRightSidebarControl(id)} key={idx} id={icon + id}>
          <div className={`right-sidebar-icon-container ${!readOnly ? 'active-container' : ''} ${rightSidebarOpen == id ? 'activesidebar' : ''}`}>
            <RelevantIcon icon={icon} style={style} />
          </div>

          {/* <UncontrolledTooltip style={{ fontWeight: "bold", backgroundColor: "#202020", color: "white" }} placement="bottom" target={icon + id}>
            {tip}
          </UncontrolledTooltip> */}
        </span>
      )
      }
    </div>
  )
}


class RightSidebar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { themecolor, LocalVars, OriginalData, formElements, currentPage, full_report, pageLimits, isSearching } = this.props.parentState;
    let { sidebarSearch, ShowHistory } = LocalVars;
    let { form, filter, filteraction, dashboard } = formElements[currentPage] ? formElements[currentPage] : [];
    let { identi } = this.props.parentProps.parentState;
    return (
      <div
        className={`${themecolor}-sidebar-theme rightSidebar ${this.props.display
          }`}
        style={{ paddingTop: (!form || form.length > 0) ? 0 : 20 }}
      >
        <div className="hand">
          <span
            style={{
              fontSize: "1rem ",
              lineHeight: "2",
              color: "#495057",
              width: "100%",
              backgroundColor: "#fff",
              height: 30
            }}
          ></span>
        </div>

        {form && form.length > 0 && LocalVars['showFilter'] && !dashboard && isSearching &&
          <div style={{ height: 52 }}></div>
        }

        {form && form.length > 0 && LocalVars['showFilter'] && !dashboard && !isSearching &&
          <div
            onClick={() => { handleFilter({ current: this, act: 'hide' }); closeSidebar(this); }}
            className={`action-icons`} id="show-create-form">
            <RelevantIcon icon="plus-color" style={{ fontSize: 30, marginLeft: -5 }} />
          </div>
        }


        {
          !form || form.length == 0 && !identi && !dashboard &&
          <div
            onClick={() => toggleFullReport({ current: this })}
            className={`action-icons`} id="full-report"
            style={{ marginLeft: 5 }}
          >
            <RelevantIcon icon={full_report ? "back-arrow" : "report-full"} style={{ fontSize: 20, color: "#5EB0F2" }} />
          </div>
        }


        {
          form && form.length > 0 && !LocalVars['showFilter'] && !identi && !dashboard &&
          <div
            id="show-search-form"
            onClick={() => handleFilter({ current: this, act: 'show' })}
            className={`action-icons`}>
            <RelevantIcon icon="back-arrow" style={{ fontSize: 20, color: "#3282b8" }} />
          </div>
        }

        {
          ShowHistory && !dashboard &&
          <RightSidebarIcons current={this} form={form} readOnly={(!OriginalData || OriginalData.length == 0) ? true : false} />
        }


        {
          dashboard &&
          <DashboardList current={this} />
        }

      </div >

    )
  }

}

export default RightSidebar;